import React from 'react';
import { SocieteGroupTable } from '../SocieteGroupTable';
import { ModalSocieteGroupAction } from '../ModalSocieteGroupAction';
import { SocieteGroupProvider } from '../../../providers';

const SocieteGroupList = function () {
    return (
        <SocieteGroupProvider>
            <SocieteGroupTable />
            <ModalSocieteGroupAction />
        </SocieteGroupProvider>
    );
};

export default SocieteGroupList;
